var Maalerstatus = Object.freeze({"Ny":0,"Varslet":1, "Avtalt":2,"Skiftet":3,"IkkeSkiftet":4 })
var Arbeidslistestatus = Object.freeze({"Deaktiv":0,"Aktivert":1})

export{
    Maalerstatus  ,
    Arbeidslistestatus 
};




// WEBPACK FOOTER //
// ./src/felles/utils/statuskoder.js